/**
 * El aviso de cookies.
 *
 * Lo que TurnPro guarda en el navegador es corto y se puede enumerar entero:
 *
 *   turnpro_sesion         cookie HttpOnly, para no pedir la contraseña en cada pantalla
 *   turnpro_dispositivo    cookie HttpOnly, reconoce el navegador para avisar de un ingreso nuevo
 *   turnpro_2fa / _google  cookies HttpOnly de minutos, mientras se completa un ingreso
 *   turnpro:tema           localStorage, la preferencia de tema
 *   turnpro:cookies        localStorage, que este aviso ya se leyo
 *
 * No hay analitica, ni publicidad, ni nada de terceros que siga a nadie. Por
 * eso el aviso informa en lugar de pedir permiso: un banner con "aceptar" y
 * "rechazar" sobre almacenamiento estrictamente necesario le miente a la
 * persona — si "rechazar" no apagara nada, el boton seria decorativo, y si
 * apagara la sesion, la aplicacion dejaria de funcionar.
 *
 * Si algun dia entra analitica o un tercero, esto tiene que pasar a ser un
 * consentimiento de verdad: dos opciones que cambien lo que se carga, con la
 * negativa por defecto.
 */

import { useCallback, useSyncExternalStore } from "react";

export const CLAVE_AVISO = "turnpro:cookies";

/** Sube si el aviso cambia lo suficiente como para volver a mostrarlo. */
export const VERSION_AVISO = "2";

function leerGuardado(): boolean {
  try {
    return localStorage.getItem(CLAVE_AVISO) === VERSION_AVISO;
  } catch {
    // Sin almacenamiento no se puede recordar que se leyo. Se muestra: es
    // preferible repetir un aviso que ocultarlo.
    return false;
  }
}

let leido: boolean = typeof window === "undefined" ? true : leerGuardado();
const suscriptores = new Set<() => void>();

function suscribir(alCambiar: () => void): () => void {
  suscriptores.add(alCambiar);
  return () => suscriptores.delete(alCambiar);
}

function leer(): boolean {
  return leido;
}

function leerEnServidor(): boolean {
  return true;
}

export function marcarLeido(): void {
  leido = true;
  try {
    localStorage.setItem(CLAVE_AVISO, VERSION_AVISO);
  } catch {
    // Vuelve a aparecer en la proxima visita. Molesto, no roto.
  }
  for (const suscriptor of suscriptores) suscriptor();
}

/** `true` mientras el aviso todavia no se leyo. */
export function useAvisoPendiente(): { pendiente: boolean; cerrar: () => void } {
  const yaLeido = useSyncExternalStore(suscribir, leer, leerEnServidor);
  const cerrar = useCallback(() => marcarLeido(), []);
  return { pendiente: !yaLeido, cerrar };
}
